module.exports = __webpack_public_path__ + "static/media/divide.b2e1cc74.svg";